import moment from 'moment';
import { appointmentStatus } from '../config/app.config';
import constants from '../constants/constants';

const DAYCARE_TYPE_TITLE = 'Daycare';
const BOARDING_PHASE_ID = constants.appointmentPhases.boarding.id;
const LIST_DATE_FORMAT = 'MM/DD/YYYY';

export const APPOINTMENT_DISPLAY_STATUS = {
  today: 'Today',
  upcoming: 'Upcoming',
  inStay: 'In Stay',
};

function facilityLocalTodayString(utcOffset) {
  const offsetMinutes = Number(utcOffset) || 0;
  return moment.utc().add(offsetMinutes, 'minutes').format(LIST_DATE_FORMAT);
}

function appointmentListDateString(dateTime, utcOffset) {
  if (!dateTime) {
    return null;
  }

  const asListDate = moment(dateTime, LIST_DATE_FORMAT, true);
  if (asListDate.isValid()) {
    return asListDate.format(LIST_DATE_FORMAT);
  }

  const asInstant = moment.utc(dateTime);
  if (!asInstant.isValid()) {
    return null;
  }

  const offsetMinutes = Number(utcOffset) || 0;
  return asInstant.add(offsetMinutes, 'minutes').format(LIST_DATE_FORMAT);
}

function parseListDay(dateString) {
  if (!dateString) {
    return null;
  }
  const day = moment(dateString, LIST_DATE_FORMAT, true);
  return day.isValid() ? day : null;
}

function isDaycareType(typeTitle) {
  return String(typeTitle || '').trim().toLowerCase() ===
    DAYCARE_TYPE_TITLE.toLowerCase();
}

function isBoardingPhase(phase) {
  return `${phase}` === `${BOARDING_PHASE_ID}`;
}

export function getAppointmentDisplayStatus({
  status,
  phase,
  dateTime,
  typeTitle,
  isBoardingOnly,
  facilityUtcOffset,
} = {}) {
  if (status !== appointmentStatus.upcoming) {
    return status;
  }

  const todayString = facilityLocalTodayString(facilityUtcOffset);
  const appointmentDateString = appointmentListDateString(
    dateTime,
    facilityUtcOffset,
  );

  if (appointmentDateString && appointmentDateString === todayString) {
    return APPOINTMENT_DISPLAY_STATUS.today;
  }

  const todayDay = parseListDay(todayString);
  const appointmentDay = parseListDay(appointmentDateString);
  const isInStay =
    !!isBoardingOnly &&
    !isDaycareType(typeTitle) &&
    isBoardingPhase(phase) &&
    appointmentDay &&
    todayDay &&
    appointmentDay.isBefore(todayDay, 'day');

  if (isInStay) {
    return APPOINTMENT_DISPLAY_STATUS.inStay;
  }

  return APPOINTMENT_DISPLAY_STATUS.upcoming;
}
